module.exports = __webpack_public_path__ + "static/Fishbowl-9a1f354770cdac1d0d360b52b732c535.jpg";